import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './../pledge.less'
import { getI18n } from 'client/i18n'
import { Button, HeadingText } from '@paypalcorp/pp-react'
import { formatMoney } from 'client/griffin'
import { Link as RouterLink } from 'react-router'
import { trackClick } from 'lib/fpti_analytics'

const i18n = getI18n('components/edit_glimpse/pledge_success')

const propTypes = {
  location: PropTypes.object,
  router: PropTypes.object,
  geo: PropTypes.object,
}
const PledgeSuccess = props => {
  const nextPathname = `/pools/c/${props.router.params.campaignId}/edit/manage`
  const { params } = props.location.state
  const { currency, campaignTitle, pledge } = params || {}
  const formattedPledgeAmount = formatMoney(currency, pledge)
  const { cdnHost } = props.geo

  if (!params) {
    return null
  }
  return (
    <div styleName="pledge-success">
      <img
        styleName="icon"
        src={`https://${cdnHost}/paypal-ui/illustrations/svg/success.svg`}
      />
      <HeadingText styleName="pledge-success-text" size="lg">
        {i18n('success_title', {
          pledge: formattedPledgeAmount,
          campaignTitle: campaignTitle,
        })}
      </HeadingText>
      <Button
        styleName="pledge-success-button "
        as={RouterLink}
        to={nextPathname}
        onClick={() => {
          trackClick({
            clickName: 'dw_giving_pledge_confirmation_dismiss_pressed',
            data: {
              event_name: 'dw_giving_pledge_confirmation_dismiss_pressed',
              dismiss_method: 'quit',
            },
          })
        }}
      >
        {i18n('done_button')}
      </Button>
    </div>
  )
}

PledgeSuccess.propTypes = propTypes

export default cssModules(PledgeSuccess, styles)
